import { render, staticRenderFns } from "./TaxInvoice.vue?vue&type=template&id=77bce3b6"
import script from "./TaxInvoice.vue?vue&type=script&lang=js"
export * from "./TaxInvoice.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoice.vue?vue&type=style&index=0&id=77bce3b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports